import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_consolidated_arap_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    acc_code: fromDatatype.VarcharDatatypeInterface;
    acc_name: fromDatatype.VarcharDatatypeInterface;
    nick_name: fromDatatype.VarcharDatatypeInterface;
    main_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    main_entity_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;  
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_fi_consolidated_arap_hdr_RowClass implements bl_fi_consolidated_arap_hdr_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    acc_code: fromDatatype.VarcharDatatypeInterface;
    acc_name: fromDatatype.VarcharDatatypeInterface;
    nick_name: fromDatatype.VarcharDatatypeInterface;
    main_entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    main_entity_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
    description: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;  
    status: fromDatatype.StatusDataFieldInterface;
    revision: fromDatatype.RevisionDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}